import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { PaginatedResultModel } from '@data-layer/models/common';
import { ManagementDocumentModel, ManagementDocumentSearchModel } from '@data-layer/models/management';
import { DocumentCreateModel, DocumentModel } from '@data-layer/models/documents';
import { ACCESS_TOKEN, TOKEN_TYPE } from '@constants/setting-keys.const';

@Injectable({
  providedIn: 'root',
})
export class DocumentsManagementRepository {
  constructor(private apiService: ApiService) {}

  public search(params: ManagementDocumentSearchModel, isShowLoader: boolean): Observable<PaginatedResultModel<ManagementDocumentModel>> {
    return this.apiService.get(`${environment.url.prefixCustoms}v2/management/documents`, { params }, { isShowLoader });
  }

  public get(id: number, isShowLoader: boolean = false): Observable<ManagementDocumentModel> {
    return this.apiService.get(`${environment.url.prefixCustoms}v2/management/documents/${id}`, null, { isShowLoader });
  }

  public getArchive(_: string, documentsIds: number[]): Observable<Blob> {
    return this.apiService.post(
      `${environment.url.prefixCustoms}v2/management/documents/zip-archive`,
      {
        referenceNumber: null,
        documentsIds,
      },
      {
        responseType: 'blob',
      },
    );
  }

  public create(document: DocumentCreateModel, isShowLoader: boolean = true): Observable<ManagementDocumentModel> {
    return this.apiService.post<DocumentModel>(`${environment.url.prefixCustoms}v2/management/documents`, document, null, {
      isShowLoader,
    });
  }

  public createCompanyDocument(companyId: number, document: DocumentCreateModel, isShowLoader: boolean = true): Observable<DocumentModel> {
    return this.apiService.post<DocumentModel>(
      `${environment.url.prefixCustoms}v2/management/companies/${companyId}/documents`,
      document,
      null,
      {
        isShowLoader,
      },
    );
  }

  public uploadFile(documentId: number, file: File, isShowLoader: boolean = true): Observable<never> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.apiService.post(
      `${environment.url.prefixCustoms}v2/management/documents/${documentId}/data`,
      formData,
      {
        headers: {
          Authorization: `${localStorage.getItem(TOKEN_TYPE)} ${localStorage.getItem(ACCESS_TOKEN)}`,
        },
      },
      { isShowLoader },
    );
  }
}
